// export const base_url = `${window.location.origin}/backend/`
// export const base_url = `http://193.239.237.144:8002/`;
// export const base_url = `http://193.239.237.147:8000/`;
// export const base_url = `http://193.239.237.149:8000/`;
// export const base_url = `http://217.145.69.50:8000/`;
// export const base_url = `http://217.145.69.58:8000/`;
// export const base_url = `http://217.145.69.29:8000/`;

 
// Chatbot api 
// export const ChatBot_Base_Url = `http://185.209.75.88:8000/`;
// export const ChatBot_Base_Url = `https://chatbot.tradestreet.in/backend/`; 

// export const base_url = `http://217.145.69.67:8000/`;
// export const base_url = `https://tools.foxittechnology.com//backend/`;
// export const base_url = `https://soptools.tradestreet.in/backend/`;
// export const base_url = `https://tools.expertedgecorporateconsultantsllp.com/backend/`;
// export const base_url = `https://tools.algoedgeinstitute.com/backend/`;
// export const base_url = `https://app.thebuildstudy.com/backend/`;
// export const base_url = `https://tools.tradestreet.in/backend/`;
// export const base_url = `https://tools.nextbrand.tech/backend/`;
// export const base_url = `https://tools.scalpingalgo.in//backend/`;
// export const base_url = `https://tools.easytrades.in//backend/`;

// export const base_url = `https://algo.markethubonline.com/backend/`;


//if superAdmin login then change the url only for it
// export const superAdmin_base_url = `${window.location.origin}/superbackend/`

// export const superAdmin_base_url = `https://soptools.tradestreet.in/superbackend/`;
// export const base_url = `http://217.145.69.50:8000/`;




// Configuration for API base URLs  
export const ChatBot_Base_Url =`https://chatbot.tradestreet.in/backend/`; 
export const superAdmin_base_url = `https://soptools.tradestreet.in/superbackend/`;



export const base_url = window.location.hostname === "localhost" ? `https://tools.tradestreet.in/backend/` : `${window.location.origin}/backend/`;

// export const base_url = window.location.hostname === "localhost" ? `https://soptools.tradestreet.in/backend/` : `${window.location.origin}/backend/`;




// export const base_url = `https://soptools.tradestreet.in/backend/`;
// export const base_url = `https://tools.technofin.tech//backend/`;


// // Configuration for API base URLs
// export const base_url = `${window.location.origin}/backend/`;
// export const ChatBot_Base_Url = `https://chatbot.tradestreet.in/backend/`; 
// export const superAdmin_base_url = `https://soptools.tradestreet.in/superbackend/`;


